export { default as MapPinLabel } from './MapPinLabel'
